module.exports = __webpack_public_path__ + "img/logout-white.2f59f661.svg";